import { Calendar } from "primereact/calendar"
import { Card } from "primereact/card"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { SelectButton } from "primereact/selectbutton"
import { useContext, useEffect, useState } from "react"
import { enumCategorieRecherche } from "../../enums/enumCategorieRecherche"
import RechercheEntrepriseCandidats from "../../pages/entreprise/RechercheEntrepriseCandidats"
import RechercheService from "../../services/rechercheService"
import { Trans } from "react-i18next"
import { MultiSelect } from "primereact/multiselect"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import "./filterPanelOffers.css"
import EntrepriseService from "../../services/entrepriseService"

export const FilterPanelCandidates = (props) => {

    const history = useHistory()
    const [localisation, setLocalisation] = useState(null);
    const [localisationOptions, setLocalisationOptions] = useState([])
    const [disponibilite, setDisponibilite] = useState(null)
    const [loadingLocalisation, setLoadingLocalisation] = useState(true)
    const [loadingProjet, setLoadingProjet] = useState(true)
    const [projetSelected, setProjetSelected] = useState(history?.location?.state?.filters?.map(x => { return x.value }) || [])
    const [projetOptions, setProjetOptions] = useState([])
    const contextRecherche = useContext(RechercheEntrepriseCandidats);
    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;

    const rechercheService = new RechercheService();
    const entrepriseService = new EntrepriseService();

    const currentYear = new Date().getFullYear()

    const majResults = (_lazyParams) => {
        contextRecherche.setLazyParams(_lazyParams);
        contextRecherche.rechercheApi(_lazyParams);
    }

    const handleChangeProjet = (e) => {
        e.preventDefault()
        try {
            let _filters = [...contextRecherche.lazyParams.filters];

            let _newFilters = _filters.filter((e) => {
                return e.categorie !== enumCategorieRecherche.Projet
            })
            if (e.value) {
                e.value.forEach(p => {
                    _newFilters.push({ categorie: enumCategorieRecherche.Projet, value: p })
                });
            }
            let _lazyParams = { ...contextRecherche.lazyParams };
            _lazyParams.first = 0;
            _lazyParams.page = 1;
            _lazyParams.filters = _newFilters;
            majResults(_lazyParams);
            setProjetSelected(e.value)
        } catch (error) {
            console.log(error);
        }
    }

    const handleChangeDisponibilite = (e) => {
        e.preventDefault()
        try {
            let _filters = [...contextRecherche.lazyParams.filters];

            let _newFilters = _filters.filter((e) => {
                return e.categorie !== enumCategorieRecherche.APartirDe
            })
            if (e.value) {
                _newFilters.push({ categorie: enumCategorieRecherche.APartirDe, value: e.value })
            }
            let _lazyParams = { ...contextRecherche.lazyParams };
            _lazyParams.first = 0;
            _lazyParams.page = 0;
            _lazyParams.filters = _newFilters;
            majResults(_lazyParams);
            setDisponibilite(e.value)
        } catch (error) {
            console.log(error);
        }
    }

    const handleChangeLocalisation = (e) => {
        e.preventDefault()
        try {
            let _filters = [...contextRecherche.lazyParams.filters];

            let _newFilters = _filters.filter((e) => {
                return e.categorie !== enumCategorieRecherche.Ville
            })
            if (e.value) {
                _newFilters.push({ categorie: enumCategorieRecherche.Ville, value: e.value, label: e.value })
            }
            let _lazyParams = { ...contextRecherche.lazyParams };
            _lazyParams.first = 0;
            _lazyParams.page = 0;
            _lazyParams.filters = _newFilters;
            majResults(_lazyParams);
            setLocalisation(e.value)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (props.offreEmploiId)
            rechercheService.getRechercheLocalisationCandidatsOffreEmploi(props.offreEmploiId)
                .then(data => {
                    setLocalisationOptions(data)
                    setLoadingLocalisation(false)
                })
            entrepriseService.getEntreprisesOfRecruteur(adminImpersonatingRecruteurId).then(id => {
            rechercheService.getRechercheProjetOfEntreprise(id)
                .then(data => {
                    setProjetOptions(data)
                    setLoadingProjet(false)
                })
        })
    }, [props.offreEmploiId])


    return (
        <div className="fpo-main">
            <h1><Trans i18nKey="offers.filter_by" /></h1>
            <div>
                <label><Trans i18nKey="project.projects" /></label>
                <div>
                    <MultiSelect
                        disabled={loadingProjet}
                        className='p-mt-2'
                        display="chip"
                        options={projetOptions}
                        value={projetSelected}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(e) => handleChangeProjet(e)}
                        placeholder="Sélectionnez un ou plusieurs projets"
                    />
                </div>
            </div>
            {props.offreEmploiId && <div>
                <label><Trans i18nKey="general.location" /></label>
                <div>
                    <Dropdown
                        className="p-mt-2"
                        disabled={loadingLocalisation}
                        value={localisation}
                        options={localisationOptions}
                        optionLabel="label"
                        onChange={(e) => handleChangeLocalisation(e)}
                        showClear
                        placeholder="Choisissez une localisation"
                    />
                </div>
            </div>}
            <div>
                <label><Trans i18nKey="general.availability" /></label>
                <div>
                    <Calendar
                        placeholder=''
                        locale="fr"
                        value={disponibilite}
                        onChange={(e) => handleChangeDisponibilite(e)}
                        monthNavigator
                        showIcon
                        yearNavigator yearRange={`${currentYear}:${currentYear + 40}`}
                        dateFormat='dd/mm/yy'
                    />
                </div>
            </div>
        </div>
    )
}